import "./ChatLoading.css";
export default function ChatLoading() {
  return <div className="loader"></div>;
}
